import {css} from 'lit';
export const styles = css`:host {
  --height: auto;
  --date-widget-bg: var(--light-secondary);
  --date-widget-text: var(--dark-text);

  display: flex;
  border-radius: var(--border-radius);
  background-color: var(--contrast-light);
  transition: background-color var(--transition-duration)
    var(--transition-timing);
}

:host([url]) {
  cursor: pointer;
  outline-offset: var(--link-focus-outline-offset);
}

:host([url][focus-within]) {
  outline: 1px solid var(--link-focus-outline);
}

:host([url]:focus-within) {
  outline: 1px solid var(--link-focus-outline);
}

@media (hover: hover) {
  :host([url]:hover) {
    background-color: var(--gray-200);
  }
}

:host([url]:active) {
  background-color: var(--gray-300);
}

xs-card-date-widget {
  --contrast-light: var(--date-widget-bg);
  --dark-text-secondary: var(--date-widget-text);
  --font-size-lg: 30px;
  --font-size-sm: 16px;
  --text-transform: capitalize;

  height: var(--height);
  width: 64px;
  border-radius: var(--border-radius) 0 0 var(--border-radius);
}

section {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: var(--height);
  padding: 16px;
  min-width: 1px;
}

.main-content {
  --link-text: var(--dark-text);
}

.main-content a {
    outline: 0;
  }

.main-content ::slotted(*) {
    margin: 0;
    font-size: var(--font-size-lg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
  }

footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

[name='footer'] {
  display: flex;
  flex: 1;
}

::slotted(xs-origin) {
  --link-text: var(--dark-text-secondary);

  margin-right: 16px;
  font-size: var(--font-size-sm);
  outline: none;
}

::slotted(xs-member) {
  --background-color: transparent;
  --member-size: 20px;
  --padding: 0;
  --name-size: var(--font-size-sm);
  --link-text: var(--dark-text-secondary);
}

ef-label {
  --background-primary: var(--danger);
  --text-primary: var(--contrast-light);
}

ef-time-range-v2 {
  font-size: var(--font-size-sm);
  color: var(--dark-text-secondary);
  line-height: 1.2;
}

ef-time-range-v2 span:last-child {
    border-left: 1px solid var(--gray-400);
    padding-left: 4px;
  }

@media (max-width: 500px) {
  :host {
    --height: auto;
  }

  footer {
    flex-direction: column;
    align-items: flex-start;
  }

  xs-origin {
    margin-bottom: 6px;
  }

  ef-label {
    --font-size-primary: 12px;

    margin-top: 6px;
  }
}
`;
export default styles;
